import { render } from "./NegocioMultiselect.vue?vue&type=template&id=29d4ce38"
import script from "./NegocioMultiselect.vue?vue&type=script&lang=js"
export * from "./NegocioMultiselect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__